import { render, staticRenderFns } from "./DebugCounter.vue?vue&type=template&id=09ba2acf"
import script from "./DebugCounter.vue?vue&type=script&lang=js"
export * from "./DebugCounter.vue?vue&type=script&lang=js"
import style0 from "./DebugCounter.vue?vue&type=style&index=0&id=09ba2acf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports